var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getTextMarkerPatch } from 'app/core/markers/models';
import { getMarker, hasSelectedUnlockedMarkers } from 'app/stores/selectors';
import { editorSlice } from '../../editor';
import { projectSlice } from '../../project';
export const editText = createAsyncThunk('editor/editText', (params, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    const state = getState();
    const hasEditableTextItemSelected = hasSelectedUnlockedMarkers(state, 1, 'Text');
    if (!hasEditableTextItemSelected) {
        return;
    }
    const { textToAppend } = params;
    dispatch(editorSlice.actions.setController({
        controller: 'text-editor',
        data: { textToAppend },
    }));
}));
export const patchText = createAsyncThunk('editor/patchText', (params, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    const { id, patch } = params;
    const state = getState();
    const marker = getMarker(state, id);
    if (!marker || marker.alias !== 'Text') {
        return;
    }
    dispatch(projectSlice.actions.itemUpdate({
        id,
        patch: getTextMarkerPatch(marker, patch),
    }));
}));
